import React from 'react';
import { ScanLineIcon } from 'lucide-react';
type BrandMarkProps = {
  tone?: 'light' | 'dark';
};
export function BrandMark({
  tone = 'light'
}: BrandMarkProps) {
  return <div className="flex items-center gap-2" data-id="element-94" data-mp="tjcbtpab1ty2">
      <span className={`flex h-9 w-9 items-center justify-center rounded-lg ${tone === 'dark' ? 'bg-white text-brand-800' : 'bg-brand-700 text-white'}`} data-id="element-95" data-mp="tk3w43ygc591">
        <ScanLineIcon className="h-5 w-5" aria-hidden="true" data-id="element-96" data-mp="1m6yd2qw28mhr" />
      </span>
      <span className={`font-serif text-xl font-bold ${tone === 'dark' ? 'text-white' : 'text-brand-800'}`} data-id="element-97" data-mp="1h8dboo52nwrq">
        CBCT Decision Map<sup className="text-[10px]" data-id="element-98" data-mp="1cglvn7jjl9fu">™</sup>
      </span>
    </div>;
}